import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCursorPointerDefaultNameWireframe from './VeltCursorPointerDefaultNameWireframe/VeltCursorPointerDefaultNameWireframe';
import VeltCursorPointerDefaultCommentWireframe from './VeltCursorPointerDefaultCommentWireframe/VeltCursorPointerDefaultCommentWireframe';
var VeltCursorPointerDefaultWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-cursor-pointer-default-wireframe", __assign({}, transformedProps), children));
};
VeltCursorPointerDefaultWireframe.Name = VeltCursorPointerDefaultNameWireframe;
VeltCursorPointerDefaultWireframe.Comment = VeltCursorPointerDefaultCommentWireframe;
export default VeltCursorPointerDefaultWireframe;
